// extracted by mini-css-extract-plugin
export var aniSpin = "j_d";
export var el = "j_b";